import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons'

const BillsAccordionLayout = ({ title, children, index, activeIndex, setActiveIndex, name }) => {
  const handleSetIndex = (index) => (activeIndex !== index) && setActiveIndex(index);

  return (
    <>
      <div onClick={() => handleSetIndex(index)} className='flex w-1/2 justify-between p-4 mt-2 rounded-md bg-white  w-full'>
        <div className='flex flex-col'>
          <div className='flex'>
            <div className='text-black font-bold text-lg'>{name}</div>
          </div>
          <div className='flex mt-2'>
            <div className='text-black text-xs'>{title}</div>
          </div>
        </div>
        <div className="flex items-center justify-center">
          {
            (activeIndex === index)
              ? <FontAwesomeIcon className='leading-7 text-black mt-1' icon={faCaretDown} />
              : <FontAwesomeIcon className='leading-7 text-black mt-1' icon={faCaretRight} />
          }
        </div>
      </div>

      {(activeIndex === index) && (
        <div className="shadow-3xl rounded-2xl shadow-cyan-500/50 p-4 mb-6">
          {children}
        </div>
      )}
    </>
  );
};

export default BillsAccordionLayout;
